import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall, } from "../../utils/ApiMethods";


const FetchSBACCIDateAction = () => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SBA_CCI_DATE_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/sba-cci/get-min-max-date`);
            var resData = Object.assign({ type: 'SUCCESS_SBA_CCI_DATE_ACTION' }, data);
            dispatch(resData);

        } catch (error) {
            dispatch({ type: 'ERROR_SBA_CCI_DATE_ACTION', error });
        }

        
        dispatch(resData);
    };
};

const FetchWoodmacReportDateAction = () => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_WOODMAC_DATE_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/woodmac/get-min-max-date`);
            var resData = Object.assign({ type: 'SUCCESS_WOODMAC_DATE_ACTION' }, data);
            dispatch(resData);

        } catch (error) {
            dispatch({ type: 'ERROR_WOODMAC_DATE_ACTION', error });
        }

        
        dispatch(resData);
    };
};

const FetchSBACCIReportCountAction = () => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SBA_CCI_REPORT_COUNT_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/sba-cci/report-count`);
            var resData = Object.assign({ type: 'SUCCESS_SBA_CCI_REPORT_COUNT_ACTION' }, data);
            dispatch(resData);

        } catch (error) {
            dispatch({ type: 'ERROR_SBA_CCI_REPORT_COUNT_ACTION', error });
        }

    };
};
const FetchSBACCIDetailPageAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SBA_CCI_DETAIL_ACTION' });
        if (payload) {

            try {
                const data = await getApiCall(`${appConstants.BASE_URL}/sba-cci/get-reports?fromDate=${payload?.fromDate}&toDate=${payload?.toDate}&reportType=${payload?.currentTab}`);
                var resData = Object.assign({ type: 'SUCCESS_SBA_CCI_DETAIL_ACTION' }, data);
                dispatch(resData);
    
            } catch (error) {
                dispatch({ type: 'ERROR_SBA_CCI_DETAIL_ACTION', error });
            }
        }
    };
};

const FetchWoodmacGetReportPageAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_WOODMAC_DETAIL_REPORT_ACTION' });
        if (payload) {

            try {
                const data = await getApiCall(`${appConstants.BASE_URL}/woodmac/get-reports?fromDate=${payload?.fromDate}&toDate=${payload?.toDate}&reportType=${payload?.currentTab}`);
                var resData = Object.assign({ type: 'SUCCESS_WOODMAC_DETAIL_REPORT_ACTION' }, data);
                dispatch(resData);
    
            } catch (error) {
                dispatch({ type: 'ERROR_WOODMAC_DETAIL_REPORT_ACTION', error });
            }
        }
    };
};

const FetchCMAPageFilterAction = () => { 
    return async function (dispatch) { 
        dispatch({ type: 'LOADING_CMA_PAGE_FILTER_ACTION' }); 
        try { 
            const data = await getApiCall(`${appConstants.BASE_URL}/cma/filter`); 
            var resData = Object.assign({ type: 'SUCCESS_CMA_PAGE_FILTER_ACTION' }, data); 
            dispatch(resData); 
        } catch (error) { 
            dispatch({ type: 'ERROR_CMA_PAGE_FILTER_ACTION', error }); 
        } 
    }; 
};

const FetchCMALineChartAction = (payload = {}) => {
    return async function (dispatch) {      
        dispatch({ type: 'LOADING_CMA_LINE_CHART_ACTION' }); 
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/cma/pricing`, payload);
            var resData = Object.assign({ type: 'SUCCESS_CMA_LINE_CHART_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_CMA_LINE_CHART_ACTION', error });
        }
    };
};

const FetchCMATableAction = (payload = {}) => {
    return async function (dispatch) {        
        dispatch({ type: 'LOADING_CMA_TABLE_ACTION' }); 
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/cma/product-price-details`, payload);
            var resData = Object.assign({ type: 'SUCCESS_CMA_TABLE_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_CMA_TABLE_ACTION', error });
        }
    };
};


const FetchCMADateAction = () => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_CMA_DATE_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/cma/min-max-date`);
            var resData = Object.assign({ type: 'SUCCESS_CMA_DATE_ACTION' }, data);
            dispatch(resData);

        } catch (error) {
            dispatch({ type: 'ERROR_CMA_DATE_ACTION', error });
        }
        dispatch(resData);
    };
};
const FetchCmaDetailReportAction = (payload = {}) => {
    return async function (dispatch) {
        if (payload) {
            const data = await getApiCall(`${appConstants.BASE_URL}/cma/reports?fromDate=${payload?.fromDate}&toDate=${payload?.toDate}`);
            var resData = Object.assign({ type: 'SUCCESS_CMA_DETAIL_REPORT_ACTION' }, data);
            dispatch(resData);
        }
    };
};

const FetchWoodmacPageFilterAction = () => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_WOODMAC_PAGE_FILTER_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/woodmac/filter`);
            var resData = Object.assign({ type: 'SUCCESS_WOODMAC_PAGE_FILTER_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_WOODMAC_PAGE_FILTER_ACTION', error });
        }
    };
};

const FetchWoodmacLineChartAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_WOODMAC_LINE_CHART_ACTION' });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/woodmac/pricing`, payload);
            var resData = Object.assign({ type: 'SUCCESS_WOODMAC_LINE_CHART_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_WOODMAC_LINE_CHART_ACTION', error });
        }
    };
};

const FetchWoodmacTableAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_WOODMAC_TABLE_ACTION' });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/woodmac/product-price-details`, payload);
            var resData = Object.assign({ type: 'SUCCESS_WOODMAC_TABLE_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_WOODMAC_TABLE_ACTION', error });
        }
    };
};

export {
    FetchSBACCIDateAction,
    FetchSBACCIReportCountAction,
    FetchSBACCIDetailPageAction,
    FetchCMAPageFilterAction,
    FetchCMALineChartAction,
    FetchCMADateAction,
    FetchCmaDetailReportAction,
    FetchCMATableAction,
    FetchWoodmacPageFilterAction,
    FetchWoodmacLineChartAction,
    FetchWoodmacTableAction,
    FetchWoodmacReportDateAction,
    FetchWoodmacGetReportPageAction
}

// /sba-cci/report-count